var map = {
	"./404.svg": 947,
	"./Categories.png": 948,
	"./Edit-menu.svg": 949,
	"./Egg.svg": 950,
	"./Emaier-Header.png": 951,
	"./Qr-4.png": 952,
	"./_duplicate.svg": 953,
	"./_overview.svg": 954,
	"./add-white.svg": 955,
	"./alert.svg": 956,
	"./all_category.svg": 957,
	"./archive.svg": 958,
	"./armchair.svg": 959,
	"./arrow-circle-right.svg": 960,
	"./arrow-left-circle.svg": 961,
	"./arrow-right-circle.svg": 962,
	"./arrow-right.svg": 963,
	"./asc-up-white.svg": 964,
	"./asc.png": 965,
	"./asc.svg": 966,
	"./back-arrow.svg": 967,
	"./barcode-icon.svg": 968,
	"./beverages.svg": 969,
	"./blue-edit-pen.svg": 970,
	"./blue-eye.svg": 971,
	"./box-office.svg": 972,
	"./broken-seat.jpg": 973,
	"./calendar_list.svg": 974,
	"./calender.svg": 357,
	"./chevron-down.svg": 975,
	"./chevron-left.svg": 976,
	"./cinema-mamagement-sidebar.svg": 977,
	"./claendar.svg": 307,
	"./clock-1.svg": 978,
	"./clock.svg": 979,
	"./close-button.svg": 707,
	"./close-white.svg": 710,
	"./close-x.svg": 301,
	"./collapse-up.svg": 980,
	"./collapse.svg": 981,
	"./connection-lost.svg": 355,
	"./consumable-raw-material.svg": 982,
	"./copy.svg": 983,
	"./copy_image_icon.png": 984,
	"./delete-red-light.svg": 985,
	"./delete-red.svg": 716,
	"./delete.svg": 690,
	"./deliver-icon.svg": 986,
	"./desc-down-white.svg": 987,
	"./desc.svg": 988,
	"./distributors-sidebar.svg": 989,
	"./download.svg": 990,
	"./dragndrop.svg": 991,
	"./dragndrop2.svg": 992,
	"./duplicate.svg": 993,
	"./duplicateScreen.svg": 994,
	"./e-wallet-icon-black.svg": 995,
	"./edit-pen-blue.svg": 996,
	"./edit-pen-white.svg": 997,
	"./edit-pen.svg": 998,
	"./edit.svg": 999,
	"./email.png": 1000,
	"./empty-image.svg": 1001,
	"./excel.svg": 1002,
	"./external-link.svg": 1003,
	"./eye.svg": 1004,
	"./filter-icon.svg": 1005,
	"./flag.svg": 1006,
	"./fnb-app-order.svg": 1007,
	"./fnb-beverages.svg": 1008,
	"./fnb-brownie.svg": 1009,
	"./fnb-combo.svg": 1010,
	"./fnb-desert.svg": 1011,
	"./fnb-eatables.svg": 1012,
	"./fnb-make-your-combo.svg": 1013,
	"./fnb-popcorn.svg": 1014,
	"./fnbtransactionIcon.svg": 1015,
	"./fullscreen-icon.svg": 717,
	"./funnel.svg": 1016,
	"./globe.svg": 1017,
	"./green-tick.svg": 1018,
	"./grid-view.svg": 1019,
	"./hide-password.svg": 358,
	"./home-icon.svg": 1020,
	"./home.svg": 1021,
	"./icon-black-play.svg": 1022,
	"./icon-dot.svg": 1023,
	"./icon-fnb.svg": 1024,
	"./icon-marketing.svg": 1025,
	"./icon-no-seat.png": 1026,
	"./icon-no-seat.svg": 1027,
	"./icon-option.svg": 1028,
	"./icon-poin-of-sale.svg": 1029,
	"./icon-recliner.svg": 1030,
	"./icon-report.svg": 1031,
	"./icon-sofa-dark-1.svg": 1032,
	"./icon-sofa-dark.png": 1033,
	"./icon-sofa-dark.svg": 1034,
	"./icon-sofa.svg": 1035,
	"./importfile.svg": 1036,
	"./info.svg": 711,
	"./info2.svg": 1037,
	"./keyboard-icon.svg": 1038,
	"./kitchen_display.svg": 1039,
	"./language-icon.svg": 302,
	"./left-caret.svg": 1040,
	"./link.svg": 1041,
	"./list-view.svg": 1042,
	"./loading.svg": 359,
	"./lock.svg": 1043,
	"./login-password.png": 360,
	"./login-user.png": 361,
	"./logout.svg": 712,
	"./masters-sidebar.svg": 1044,
	"./merchandise.svg": 1045,
	"./minus.svg": 1046,
	"./movie-pass-svg.svg": 700,
	"./movie-rolling.svg": 1047,
	"./mulitSchedule.svg": 1048,
	"./multicurrency.svg": 1049,
	"./multifnb.svg": 1050,
	"./nav-plus.svg": 1051,
	"./new_filter_icon.svg": 1052,
	"./no-image.svg": 1053,
	"./no-schedule.svg": 136,
	"./non-veg-mark.png": 1054,
	"./non-veg-mark.svg": 1055,
	"./notification.svg": 1056,
	"./open-link-blue.svg": 1057,
	"./openPlanned.svg": 1058,
	"./overview.svg": 1059,
	"./overview2.svg": 1060,
	"./pdf-icon.svg": 1061,
	"./pdf.svg": 1062,
	"./pickup-ticket-icon.svg": 1063,
	"./pickupfnb.svg": 1064,
	"./play.svg": 1065,
	"./plus.svg": 1066,
	"./pointofsale-1.svg": 1067,
	"./pointofsale-2.svg": 1068,
	"./pointofsale.png": 1069,
	"./portfolio.svg": 1070,
	"./pos-fnb-no-itmes.svg": 703,
	"./pos-refresh.svg": 1071,
	"./primary/chevron-down.svg": 1072,
	"./primary/download.svg": 1073,
	"./primary/edit.svg": 1074,
	"./primary/filter.svg": 1075,
	"./primary/printer.svg": 1076,
	"./print-icon.svg": 1077,
	"./print.svg": 1078,
	"./question.svg": 1079,
	"./question1.svg": 1080,
	"./question2.svg": 718,
	"./question3.svg": 1081,
	"./recliner-1.svg": 1082,
	"./recliner.png": 1083,
	"./refund-icon.svg": 1084,
	"./reload-icon-pos.svg": 1085,
	"./reload-icon.svg": 1086,
	"./restore.svg": 1087,
	"./right-caret.svg": 1088,
	"./role-management-sidebar.svg": 1089,
	"./save.svg": 1090,
	"./schedule-icon.svg": 1091,
	"./school-calendar.svg": 1092,
	"./search-global-white.svg": 1093,
	"./search-global.svg": 1094,
	"./search.svg": 719,
	"./searchIcon.svg": 1095,
	"./seat-icon-2.svg": 1096,
	"./seat-icon.svg": 1097,
	"./seat-icons/3-wheelChair.png": 1098,
	"./seat-icons/block_seat_new.png": 1099,
	"./seat-icons/broken-seat-1.svg": 1100,
	"./seat-icons/broken-seat-2.svg": 1101,
	"./select-food.png": 720,
	"./settings.svg": 1102,
	"./show-password.svg": 362,
	"./slider-triangle.svg": 1103,
	"./snack.svg": 713,
	"./sort.svg": 1104,
	"./star-empty.svg": 1105,
	"./star-fill.svg": 1106,
	"./success-tick.svg": 1107,
	"./suitcase.svg": 1108,
	"./swap.svg": 1109,
	"./tick-green-item.svg": 721,
	"./tick-green.svg": 1110,
	"./ticket-icon.svg": 1111,
	"./trash.svg": 1112,
	"./unpaid-reservation.svg": 694,
	"./updown-white.svg": 1113,
	"./updown.svg": 1114,
	"./user-attribute.svg": 1115,
	"./user-attributes.svg": 1116,
	"./user-female.svg": 1117,
	"./user-male-white.svg": 1118,
	"./user-male.svg": 1119,
	"./user-profile.svg": 1120,
	"./userProfile.png": 1121,
	"./veg-food-mark-white.png": 1122,
	"./veg-foog-mark-trans.png": 1123,
	"./view.png": 1124,
	"./view.svg": 1125
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 946;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 946
// module chunks = 37